export const RANKED_COLOR = [
  'rgba(58,141,199,255)',
  'rgba(116,192,225,255)',
  'rgba(35,147,152,255)',
  'rgba(220,238,232,255)',
  'rgba(156,92,163,255)',
]
